import { Iodine } from "@kingshott/iodine";

const flkty = {};

const setUpcomingEvent = (element, flkty) => {
    const cards = Array.prototype.slice.call(element.querySelectorAll(".profile-schedule"));
    const upcoming = element.querySelector(".profile-schedule-upcoming");
    if (!upcoming) return;
    const upcomingIndex = cards.indexOf(upcoming);
    flkty.select(upcomingIndex, true, true);
};

document.querySelectorAll(".profile-schedule-slider").forEach((element) => {
    const index = element.getAttribute("data-profile-schedule-slider");

    // eslint-disable-next-line no-undef
    flkty[index] = new Flickity(element, {
        cellSelector: ".profile-schedule",
        wrapAround: true,
        cellAlign: "left",
        arrowShape:
            "M61.722 23.456a1.667 1.667 0 01.195 2.125l-.195.23-25.108 25.111 25.111 25.111a1.667 1.667 0 01.192 2.125l-.195.23a1.667 1.667 0 01-2.125.195l-.23-.194L33.077 52.1a1.666 1.666 0 01-.194-2.125l.195-.23 26.289-26.29a1.667 1.667 0 012.355 0z",
    });

    setTimeout(() => {
        flkty[index].resize();
    }, 10);

    setTimeout(() => {
        setUpcomingEvent(element, flkty[index]);
    }, 50);
});

window.addEventListener("resize-profile-schedule", ({ target, detail }) => {
    const slider = target.closest(".profile-schedule-slider");
    if (!slider) {
        return;
    }

    const index = slider.getAttribute("data-profile-schedule-slider");
    if (detail === "show") {
        flkty[index].nextButton.deactivate();
        flkty[index].prevButton.deactivate();
        flkty[index].pageDots.deactivate();
        flkty[index].options.draggable = false;
        flkty[index].updateDraggable();
    } else if (detail === "hide") {
        flkty[index].nextButton.activate();
        flkty[index].prevButton.activate();
        flkty[index].pageDots.activate();
        flkty[index].options.draggable = true;
        flkty[index].updateDraggable();
    }

    setTimeout(() => {
        flkty[index].resize();
    }, 10);
});

const DEFAULT_SCHEDULE_FORM_DATA = {
    name: {
        value: "",
        errorMessage: false,
        blurred: false,
        rules: ["required"],
    },
    question: {
        value: "",
        errorMessage: false,
        blurred: false,
        rules: ["required", "maximum:200"],
    },
    dsgvo: {
        value: false,
        errorMessage: false,
        blurred: false,
        rules: ["truthy"],
    },
};

window.profileSchedule = (messages) => {
    return {
        dateNow: Date.now(),
        startDate: "",
        endDate: "",
        iodineInstance: null,
        isVisibleForm: false,
        isFormSend: false,
        formSendError: false,
        isButtonLoading: false,
        formData: JSON.parse(JSON.stringify(DEFAULT_SCHEDULE_FORM_DATA)),
        talk: null,
        messages,

        get is20MinBeforeLive() {
            const startDate = new Date(this.startDate * 1000);
            startDate.setMinutes(startDate.getMinutes() - 20);
            return this.dateNow < this.startDate * 1000 && this.dateNow >= startDate.getTime();
        },

        get isBeforeLive() {
            return this.dateNow < this.startDate * 1000;
        },

        get isAfterLive() {
            return this.dateNow >= this.endDate * 1000;
        },

        get isLive() {
            return this.dateNow >= this.startDate * 1000 && this.dateNow <= this.endDate * 1000;
        },

        initialize() {
            this.iodineInstance = new Iodine();
            this.iodineInstance.messages.required = this.messages.required;
            this.iodineInstance.messages.truthy = this.messages.required;
            this.iodineInstance.messages.maximum = this.messages.maximum;

            Object.keys(this.formData).map((key) => this.$watch(`formData.${key}.value`, () => this.changeValue(key)));
        },

        showForm() {
            this.isVisibleForm = true;
            this.isFormSend = false;
            this.formSendError = false;
        },

        hideForm() {
            this.isVisibleForm = false;
            this.resetForm();
        },

        resetForm() {
            this.isFormSend = false;
            this.formSendError = false;
            this.isButtonLoading = false;
            this.formData = JSON.parse(JSON.stringify(DEFAULT_SCHEDULE_FORM_DATA));
        },

        changeValue(key) {
            this.formData[key].blurred = true;
            this.updateErrorMessages(key);
        },

        updateErrorMessages(key) {
            this.formData[key].errorMessage = this.getErrorMessage(key);
        },

        getErrorMessage(key) {
            const error = this.iodineInstance.is(this.formData[key].value, this.formData[key].rules);
            if (error !== true && this.formData[key].blurred) {
                return this.iodineInstance.getErrorMessage(error);
            }
            return false;
        },

        form: {
            ["@submit.prevent"](event) {
                const invalidElements = Object.keys(this.formData).filter((key) => {
                    return this.iodineInstance.is(this.formData[key].value, this.formData[key].rules) !== true;
                });

                if (invalidElements.length > 0) {
                    Object.keys(this.formData).map((key) => {
                        this.formData[key].blurred = true;
                        this.updateErrorMessages(key);
                    });
                } else {
                    this.isButtonLoading = true;
                    const action = event.target.getAttribute("action");
                    let data = { talk: this.talk };
                    Object.keys(this.formData).map((key) => {
                        data[key] = this.formData[key].value;
                    });

                    fetch(action, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ data }),
                    })
                        .then((response) => response.json())
                        .then((json) => {
                            if (!json.success) {
                                throw new Error(json.message);
                            }
                            this.isFormSend = true;
                            this.isButtonLoading = false;
                        })
                        .catch((error) => {
                            this.isFormSend = true;
                            this.formSendError = error.message;
                            this.isButtonLoading = false;
                        });
                }
            },
        },
    };
};
